import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with longer timeout for DataForSEO API calls
const axiosLongTimeout = axios.create({
  timeout: 180000 // 3 minutes for DataForSEO API calls
});

export const api = {
  // Generic POST
  post: (endpoint, data) => axios.post(`${BACKEND_URL}${endpoint}`, data),
  
  // Long timeout POST (for DataForSEO)
  postLongTimeout: (endpoint, data) => axiosLongTimeout.post(`${BACKEND_URL}${endpoint}`, data),
  
  // Newsletter
  subscribeNewsletter: (email) => axios.post(`${API}/newsletter/subscribe`, { email }),
  getSubscribers: (adminPassword) => axios.get(`${API}/newsletter/subscribers`, { params: { admin_password: adminPassword } }),

  // Quiz Leads
  submitQuizLead: (data) => axios.post(`${API}/quiz-leads`, data),
  getQuizLeads: (adminPassword) => axios.get(`${API}/quiz-leads`, { params: { admin_password: adminPassword } }),

  // Casinos
  getCasinos: () => axios.get(`${API}/casinos`),
  createCasino: (data) => axios.post(`${API}/casinos`, data),

  // Articles
  getArticles: () => axios.get(`${API}/articles`),
  createArticle: (data) => axios.post(`${API}/articles`, data),
  getArticle: (slug) => axios.get(`${API}/articles/${slug}`),
  
  // Blog Posts (unified - articles + spokes)
  getBlogPosts: (lang) => axios.get(`${API}/blog-posts`, { params: { lang } }),
  
  // Blog Content (unified - articles + spokes)
  getBlogContent: (slug) => axios.get(`${API}/blog-content/${slug}`),

  // FAQ
  getFaqs: () => axios.get(`${API}/faqs`),
  createFaq: (data) => axios.post(`${API}/faqs`, data),

  // SEO Generation
  generateSEO: (data) => axios.post(`${API}/seo/generate`, data),
  getSEOHistory: () => axios.get(`${API}/seo/history`),

  // Seed
  seedData: () => axios.post(`${API}/seed`),

  // Localized Landing Page
  getLandingData: (lang) => axios.get(`${API}/landing-data/${lang}`),
  getSupportedLanguages: () => axios.get(`${API}/supported-languages`),

  // Latest Articles for Landing Page
  getLatestArticles: (limit = 6) => axios.get(`${API}/articles/latest/${limit}`),

  // Pillar Pages
  getPillars: () => axios.get(`${API}/pillars`),
  getPublishedPillars: () => axios.get(`${API}/pillars/published`),
  getPillar: (lang, slug) => axios.get(`${API}/pillars/${lang}/${slug}`),
  createPillar: (data) => axios.post(`${API}/pillars`, data),
  updatePillar: (lang, slug, data) => axios.put(`${API}/pillars/${lang}/${slug}`, data),

  // SEO Audit
  runSEOAudit: (lang, slug) => axios.post(`${API}/seo-audit?pillar_lang=${lang}&pillar_slug=${slug}`),
  auditAllPillars: () => axios.get(`${API}/seo-audit/all`),
  
  // Spoke SEO Audit
  getSpokes: () => axios.get(`${API}/spokes`),
  getSpoke: (lang, slug) => axios.get(`${API}/spokes/${lang}/${slug}`),
  runSpokeAudit: (lang, slug) => axios.post(`${API}/seo-audit/spoke?spoke_lang=${lang}&spoke_slug=${slug}`),
  auditAllSpokes: () => axios.get(`${API}/seo-audit/spokes/all`),
  
  // PSEO Audit
  getPSEOPages: () => axios.get(`${API}/pseo/pages?limit=500`),
  runPSEOAudit: (slug) => axios.post(`${API}/seo-audit/pseo?slug=${slug}`),
  auditAllPSEO: () => axios.get(`${API}/seo-audit/pseo/all`),
  
  // Site-Wide Audit
  runSiteAudit: () => axios.get(`${API}/site-audit`),
  
  // Authors (E-E-A-T)
  getAuthors: () => axios.get(`${API}/authors`),
  getAuthor: (id) => axios.get(`${API}/authors/${id}`),
  
  // PSEO Pages - dedicated method like getBlogContent
  getPSEOPage: (slug) => axios.get(`${API}/pseo/pages/${slug}`),
  getPSEORelated: (slug) => axios.get(`${API}/pseo/pages/${slug}/related`),
  
  // Generic GET
  get: (endpoint) => axios.get(`${BACKEND_URL}${endpoint}`),
  
  // Generic PUT
  put: (endpoint, data) => axios.put(`${BACKEND_URL}${endpoint}`, data),
  
  // Generic DELETE
  delete: (endpoint) => axios.delete(`${BACKEND_URL}${endpoint}`),
  
  // Whale Tracker
  getWhalesLive: (params) => axios.get(`${API}/whales/live`, { params }),
  getWhalesStats: () => axios.get(`${API}/whales/stats`),
  getWhalesCasinos: () => axios.get(`${API}/whales/casinos`),
  triggerWhaleScan: () => axios.post(`${API}/whales/scan`),
  getAirdropSettings: () => axios.get(`${API}/whales/airdrop/settings`),
  updateAirdropSettings: (data) => axios.post(`${API}/whales/airdrop/settings`, data),
  getOutreachReport: () => axios.get(`${API}/whales/outreach/report`),
  getTwitterStats: () => axios.get(`${API}/whales/twitter/stats`),
  updateTwitterSettings: (data) => axios.post(`${API}/whales/twitter/settings`, data),
  getENSStatus: () => axios.get(`${API}/whales/ens/status`),
};

export default api;
